import { DropdownIcon } from '@libs/components';
import styled from 'styled-components';

type InsideContainerProps = {
  showSeparator?: boolean;
};

export const Container = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  height: fit-content;
  background-color: ${({ theme }) => theme.colors.surface.tertiary};
`;
export const InsideContainer = styled.div<InsideContainerProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.8rem 0 1.6rem;
  border-right: 1px solid
    ${({ theme, showSeparator }) =>
      !showSeparator ? 'transparent' : theme.colors.borders.default};
`;
export const IconWrapper = styled.div`
  width: 5rem;
  height: 5rem;
  margin-bottom: 0.8rem;
`;
export const TittleWrapper = styled.div`
  position: absolute;
  top: -2rem;
  background-color: ${({ theme }) => theme.colors.surface.default};
  border-radius: ${({ theme }) => theme.borderRadius.x4};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4rem;
  padding: 0 2rem;
  ${({ theme }) => theme.media.laptop`
  padding: 0 3.2rem;

  `}
`;
export const Separator = styled.div`
  width: 0.1rem;
  height: -webkit-fill-available;
  background-color: ${({ theme }) => theme.colors.borders.default};
`;
export const ArrowWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  top: 45%;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  background-color: ${({ theme }) => theme.colors.surface.default};
  box-shadow: ${({ theme }) => theme.shadows.lg};
`;
export const CustomImg = styled.img`
  width: 100%;
  object-fit: cover;
`;
export const CustomArrowIcon = styled(DropdownIcon)`
  transform: rotate(-90deg);
`;
